import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { OfferProposerRole } from "@hybrid-escrow/shared";
import { apiClient } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { POLL } from "../lib/polling";
import { Money } from "../components/Money";
import { OfferStatusBadge } from "../components/StatusBadge";
import { OfferActions } from "../components/OfferActions";
import { EmptyState, ErrorBanner, LoadingState } from "../components/States";
import { usePageMeta } from "../lib/seo";

export function MyOffersPage() {
  usePageMeta({
    title: "Your offers",
    description: "Best Offer negotiations you've sent to sellers.",
    path: "/offers",
    index: false,
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.myOffers,
    queryFn: ({ signal }) => apiClient.getMyOffers({}, signal),
    refetchInterval: POLL.list,
  });

  return (
    <div className="stack">
      <h1>Your offers</h1>
      <p className="muted">Offers you've made on other sellers' listings.</p>

      {isLoading && <LoadingState label="Loading your offers…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}
      {data && data.items.length === 0 && (
        <EmptyState title="No offers yet">
          <p>
            Open a <Link to="/">listing</Link> and click "Make an offer" to negotiate a price.
          </p>
        </EmptyState>
      )}

      {data && data.items.length > 0 && (
        <div className="stack" style={{ gap: "var(--space-2)" }}>
          {data.items.map((offer) => (
            <div key={offer.id} className="card stack">
              <div className="row row--between">
                <Link to={`/listings/${offer.listingId}`}>
                  <strong>{offer.listingTitle}</strong>
                </Link>
                <OfferStatusBadge status={offer.status} />
              </div>
              <div className="row row--between">
                <span className="text-sm muted">
                  Listed at <Money baseUnits={offer.listingPriceBaseUnits} className="text-sm" />
                </span>
                <span>
                  Current offer: <Money baseUnits={offer.currentAmountBaseUnits} />
                </span>
              </div>
              <OfferActions offer={offer} viewerRole={OfferProposerRole.BUYER} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
